import React from 'react';
import PropTypes from 'prop-types';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';

export function HelpPopupTitle({
  i18n, nameKey, helpTopic, itemNameKey,
}) {
  return (
    <>
      <span className="column-name-text">{i18n.getString(nameKey)}</span>
      {helpTopic && itemNameKey && <HelpPopupInline
        topic={helpTopic}
        ariaLabel={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: i18n.getString(itemNameKey) })}
      />}
    </>
  );
}

HelpPopupTitle.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  nameKey: PropTypes.string.isRequired,
  helpTopic: PropTypes.string,
  itemNameKey: PropTypes.string,
};

HelpPopupTitle.defaultProps = {
  helpTopic: null,
  itemNameKey: null,
};
